import {http} from './index';

class FileService {

    getPresignedURL(files) {
        if(!Array.from(files).every((file) => file instanceof File)){
            throw new Error('TRYING_TO_UPLOAD_NON_FILE');
        }
        return http.post('/service/file', { filenames: Array.from(files).map((file) => file.name) });
    }

    upload(presignedURL, file) {
        return http.put(presignedURL, file, {
            headers: {
                'Content-Type': file.type || 'application/octet-stream',
            },
        });
    }

    delete(entity, id) {
        //return http.delete(`/${entity}/${id}`);
    }
}

export default FileService;
